<template>
  <v-navigation-drawer
    app
    class="pa-2"
    clipped
    color="secondarybackground"
    @input="$emit('input', value)"
    right
    v-if="$slots.default"
    :value="value"
    :width="285"
  >
    <slot />
  </v-navigation-drawer>
</template>
<script>
export default {
  name: 'CustomRightDrawer',
  props: {
    value: { type: Boolean, required: false },
  },
};
</script>
